/**
 * Legacy ResourceApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.resourceApi`) keep resolving.
 *
 * The actual `ResourceApiService` is now exposed indirectly: the Angular 18
 * `ApiService` facade (registered as the downgraded `'ApiService'` in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts) exposes
 * `apiService.resource` as an `inject(ResourceApiService)` Angular 18 class.
 * The actual implementation lives at
 *   apps/b2b-frontend/app/core/api/resource/resource-api.service.ts
 *
 * Do NOT register `.service('ResourceApiService', ...)` here — nothing
 * consumes it directly anymore.
 */
angular.module('acme.common.service.resourceApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion',
]);
